export const MenuRoutes = {
  PRESCRIPTION: '/prescription',
  REFERRALS: '/referrals',
  REFERRAL_RESULTS: '/test-results',
  MEDICAL_VISITS: '/medical-visits',
  MECICAL_VISITS_FUTURE: '/medical-visits/future',
  MEDICAL_VISITS_PAST: '/medical-visits/past',
  DOCTOR_NOTES: '/medical-notes',
  PROFILE: '/profile',
  ACCOUNT: '/account',
  DEBIT_CARD: '/debit-card',
  CLAIMS: '/claims',
  PAYMENTS: '/payments',
  CONVERAGE_HMO_HISTORY: '/HMO-history/converage',
  CLAIMS_HMO_HISTORY: '/HMO-history/claims',
  PAYMENTS_HMO_HISTORY: '/HMO-history/payments',
  HMO_HISOTRY_DATA: '/hmo-history-data',
}
